import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match, RouteComponentProps } from 'react-router-dom';

//Components
// import { LCAlert } from '../../../components/alert';
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
import { VehicleEditPayload, VehicleById, LightStructure, Vehicle, TParams } from '../../../redux/reducers/api-types';
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import {
    actions as vehicleActions,
    selectors as vehicleSelectors,
    types as vehicleActionTypes,
} from '../../../redux/reducers/vehicles';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import {
    actions as partnerActions,
    selectors as partnerSelectors,
    makeMemoizedGetModelsName,
} from '../../../redux/reducers/partners';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';

interface VehicleEditProps extends WithTranslation, RouteComponentProps {
    match: match<TParams>;
    vehicles: VehicleById;
    vehicleModels: LightStructure[];
    vehicleColors: LightStructure[];
    vehicleMotorizations: LightStructure[];
    getVehicleError: ErrorPayload;
    editVehicleError: ErrorPayload;
    getVehicleModelsMotorizationAndColorsError: ErrorPayload;
    getVehicle: (id: string) => void;
    editVehicle: (id: string, payload: VehicleEditPayload) => any;
    isEditingVehicle: boolean;
    getPartnerModels: () => void;
    getPartnerColors: () => void;
    getPartnerMotorizations: () => void;
}

interface VehicleEditState {
    formData: any;
}

class VehicleEditPage extends React.Component<VehicleEditProps, VehicleEditState> {
    alertRef: any;

    constructor(props: VehicleEditProps) {
        super(props);
        this.state = {
            formData: {
                registration_number: '',
                vehicle_model_id: '',
                vehicle_color_id: '',
                vehicle_motorization_id: '',
                // insurance_validity_date: '',
                // immatriculation_date: '',
                // dispatch_groups: ['normal'],
                // the_dispatch_groups: { normal: true },
            },
        };
    }

    componentDidMount() {
        const {
            match,
            vehicleModels,
            vehicleColors,
            vehicleMotorizations,
            getVehicle,
            getPartnerModels,
            getPartnerColors,
            getPartnerMotorizations,
        } = this.props;
        const id = match.params.id;
        getVehicle(id);

        if (Object.entries(vehicleModels).length === 0) {
            getPartnerModels();
        }
        if (Object.entries(vehicleColors).length === 0) {
            getPartnerColors();
        }
        if (Object.entries(vehicleMotorizations).length === 0) {
            getPartnerMotorizations();
        }
    }

    static getDerivedStateFromProps(props, state) {
        const id = props.match.params.id;
        const payload: Vehicle = props.vehicles[id];
        if (payload) {
            const formPayload = {
                registration_number: payload.registration_number,
                vehicle_model_id: payload.vehicle_model.id,
                vehicle_color_id: payload.vehicle_color.id,
                vehicle_motorization_id: payload.vehicle_motorization?.id,
            };
            return { formData: { ...state.formData, ...formPayload } };
        }
        return null;
    }

    generateInputs() {
        const { t, vehicleModels, vehicleColors, vehicleMotorizations } = this.props;
        if (vehicleModels?.length > 0 && vehicleColors?.length > 0 && vehicleMotorizations?.length > 0) {
            const inputs: FormDatas[] = [
                {
                    title: t('partner:add_vehicle.edit'),
                    datas: [
                        {
                            id: 'vehicle_model_id',
                            label: t('partner:add_vehicle.model'),
                            options: vehicleModels,
                            required: true,
                        },
                        {
                            id: 'vehicle_color_id',
                            label: t('partner:add_vehicle.color'),
                            options: vehicleColors,
                            required: true,
                        },
                        {
                            id: 'registration_number',
                            label: t('partner:add_vehicle.imma'),
                            required: true,
                            placeholder: 'XXX-555-XXX',
                        },
                        // {
                        //     id: 'insurance_validity_date',
                        //     label: t('partner:add_vehicle.valid_insurance'),
                        //     type: 'date',
                        //     required: true,
                        // },
                        // {
                        //     id: 'immatriculation_date',
                        //     label: t('partner:add_vehicle.date_imma'),
                        //     type: 'date',
                        //     required: true,
                        // },
                        {
                            id: 'vehicle_motorization_id',
                            label: t('motorization'),
                            options: vehicleMotorizations,
                            required: true,
                        },
                    ],
                },
            ];
            return inputs;
        }
        return [];
    }

    render() {
        const {
            match,
            vehicles,
            vehicleModels,
            vehicleColors,
            vehicleMotorizations,
            editVehicle,
            getVehicleError,
            editVehicleError,
            isEditingVehicle,
            getVehicleModelsMotorizationAndColorsError,
        } = this.props;
        const id = match.params.id;
        const payload = vehicles[id];

        return (
            <App needRights={{ name: AccountRight.PARTNER_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={getVehicleError || editVehicleError} />
                <ErrorMessage payload={getVehicleModelsMotorizationAndColorsError} />
                {payload?.id != null && (
                    <EnhancedForm
                        payload={this.state.formData}
                        inputs={this.generateInputs()}
                        backRoute={`${paths.vehicles}/${id}`}
                        // moreView={
                        //     <LCAlert
                        //         onRef={(ref) => (this.alertRef = ref)}
                        //         details={t('form.error_age')}
                        //         type="error"
                        //     />
                        // }
                        loader={isEditingVehicle}
                        onSubmit={(formData) => {
                            this.setState({
                                formData: formData,
                            });
                            // if (false) {
                            //     this.alertRef.showAlert();
                            // } else {
                            //     this.alertRef.closeAlert();
                            // console.log(formData, vehicleColors, vehicleModels);
                            const editPayload = {
                                ...formData,
                                model: vehicleModels.find((m) => Number(m.id) === Number(formData.vehicle_model_id))
                                    ?.name,
                                color: vehicleColors.find((c) => Number(c.id) === Number(formData.vehicle_color_id))
                                    ?.name,
                                motorization: vehicleMotorizations.find(
                                    (m) => Number(m.id) === Number(formData.vehicle_motorization_id),
                                )?.name,
                            };
                            editVehicle(id, editPayload);
                            // }
                        }}
                    />
                )}
            </App>
        );
    }
}

const VehicleEditPageWithTranslation = withTranslation(['vehicle', 'partner', 'common'])(VehicleEditPage);

const makemapStateToProps = () => {
    const getModelsName = makeMemoizedGetModelsName();

    const mapStateToProps = (state, ownProps) => {
        return {
            vehicles: vehicleSelectors.vehicles(state),
            vehicleModels: getModelsName(state, ownProps),
            vehicleColors: partnerSelectors.vehicleColors(state),
            vehicleMotorizations: partnerSelectors.vehicleMotorizations(state),
            getVehicleError: errorSelectors.getVehicleError(state),
            editVehicleError: errorSelectors.editVehicleError(state),
            isEditingVehicle: pendingSelectors.isPending(state, vehicleActionTypes.EDIT_VEHICLE),
            getVehicleModelsMotorizationAndColorsError:
                errorSelectors.getVehicleModelsMotorizationAndColorsError(state),
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = {
    getVehicle: vehicleActions.getVehicle,
    editVehicle: vehicleActions.editVehicle,
    getPartnerModels: partnerActions.getPartnerModels,
    getPartnerColors: partnerActions.getPartnerColors,
    getPartnerMotorizations: partnerActions.getPartnerMotorizations,
};

export default connect(makemapStateToProps, mapDispatchToProps)(VehicleEditPageWithTranslation);
